import DashboardBusinessCard from "./DashboardBusinessCard";

export default DashboardBusinessCard;
